import { render, staticRenderFns } from "./CompetitionInfo.vue?vue&type=template&id=0c0f0285"
import script from "./CompetitionInfo.vue?vue&type=script&lang=js"
export * from "./CompetitionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports